import React from "react";
import { Box, Text, type BoxProps, type TextProps } from "@chakra-ui/react";

interface WithKickerProps {
  children: React.ReactNode;
  size?: TextProps["fontSize"];
  mt?: BoxProps["mt"];
  textAlign?: BoxProps["textAlign"];
  fontWeight?: TextProps["fontWeight"];
  fontStyle?: TextProps["fontStyle"];
  color?: TextProps["color"];
  variant?: "standard" | "double" | "triple";
}

export default function WithKicker({
  children,
  size = { base: "sm", md: "md" },
  mt = { base: 1, md: 2 },
  textAlign = { base: "center", md: "left" },
  fontWeight = "medium",
  fontStyle = "italic",
  color = "moveon.publicFont",
  variant: _variant = "standard", // reserved for future spacing variants
}: WithKickerProps) {
  void _variant;

  return (
    <Box mt={mt} textAlign={textAlign}>
      <Text
        as="p"
        fontSize={size}
        fontWeight={fontWeight}
        color={color}
        fontStyle={fontStyle}
      >
        {children}
      </Text>
    </Box>
  );
}
